<template>
  <div
    v-bind="$attrs"
    class="flex flex-col items-start bg-cadet-gray bg-opacity-5 flex-grow flex-shrink-0 flex-basis-0 rounded-lg border-t border-cadet-gray border-opacity-15 flex-1"
  >
    <slot />
    <p v-if="name" class="text-dark4">
      {{ name }}
    </p>
  </div>
</template>
<script setup lang="ts">
  defineOptions({ inheritAttrs: false });

  interface Props {
    name?: string;
  }

  defineProps<Props>();
</script>
